
import HeroAreaInternal from '@/components/modules/HeroAreaInternal'
export default {
    components: {
        HeroAreaInternal
    },
        layout: 'internal-hero'
}
